import { useClerk } from '@clerk/react';
import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';

export default function Logout() {
  const { signOut } = useClerk();

  useEffect(() => {
    signOut({ redirectUrl: '/' });
  }, [signOut]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100dvh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
